module.exports = __webpack_public_path__ + "img/Honig-aus-2021-1100.19f7966d.jpg";